import { Model, belongsTo } from 'miragejs'

export default Model.extend({
  student: belongsTo(),
})
